import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/SuccessScreen.css';
import '../../styles/variables.css';
import logo from '../../logo.png';
import { BIOBANK_ROUTES } from '../../constants/routes';

const SuccessScreen = () => {
  const navigate = useNavigate();

  const handleDashboardRedirect = () => {
    navigate(BIOBANK_ROUTES.DASHBOARD);
  };

  return (
    <div className="success-container">
      <img src={logo} alt="Logo" className="success-logo" />

      <h2 className="success-title" style={{
        fontFamily: 'var(--title-font)',
        color: 'var(--title-color)',
        fontWeight: 'var(--title-font-weight)',
        fontSize: 'var(--title-size)'
      }}>Registration Successful!</h2>

      <p className="success-text" style={{
        fontFamily: 'var(--body-font)',
        color: 'var(--body-color)',
        fontWeight: 'var(--body-font-weight)',
        fontSize: 'var(--body-size)'
      }}>
        Thank you for registering. You are now ready to explore the PROVENANCE Clinicogenomic Data Center.
      </p>

      <button className="proceed-button" style={{
        fontFamily: 'var(--button-font)',
        backgroundColor: 'var(--tamu-maroon)',
        color: 'var(--tamu-white)',
        fontWeight: 'var(--header-font-weight)',
        fontSize: 'var(--header-size)',
        padding: '10px 20px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer'
      }} onClick={handleDashboardRedirect}>
        Proceed to Dashboard
      </button>
    </div>
  );
};

export default SuccessScreen;
